import getErrorKey from '../../components/address/getErrorKey';
import getErrorPrefix from '../getErrorPrefix';

const errorPrefixPlural = 'errors.formFields.minUpper';

const minUpper = (min, fieldName) => (value) => {
  if (!value) return; // This validator doesn't enforce 'required' constraint, only min length IF value has been provided.
  
  const errorPrefix = getErrorPrefix(errorPrefixPlural, min);
  const errorKey = getErrorKey(fieldName, errorPrefix);
  
  return (value.trim().match(/[A-Z]/g) || []).length < min ? [errorKey, min] : undefined;
};

export default minUpper;
